import React, { useEffect } from "react";
import PropTypes from "prop-types";

// context
import { usePanelOverlay } from "../usePanelOverlay";

// hooks
import { useDisableBodyScroll } from "frontend/hooks/useDisableBodyScroll.js";

// MountingWrapper
const MountingWrapper = ({ children }) => {
    const { setHasOpened, hasOpened, isOpen, close } = usePanelOverlay();
    const { disableBodyScroll } = useDisableBodyScroll();

    useEffect(() => {
        if (isOpen && !hasOpened) {
            setHasOpened(true);
        }
    }, [isOpen, hasOpened]);

    useEffect(() => {
        if (isOpen) {
            disableBodyScroll(true);
        }

        // Cleanup styles when the component unmounts
        return () => {
            disableBodyScroll(false);
        };
    }, [hasOpened, isOpen]);

    useEffect(() => {
        const handleKeyDown = event => {
            if (event.key === "Escape") {
                close();
            }
        };

        // Add event listener
        document.addEventListener("keydown", handleKeyDown);

        // Cleanup the event listener
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    // close panel if user resizes window
    useEffect(() => {
        const handleResize = () => {
            close(false);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return <>{children}</>;
};

export default MountingWrapper;

// prop-types
MountingWrapper.propTypes = {
    children: PropTypes.any
};
